module.exports = __webpack_public_path__ + "img/Austin.e9b9b846.jpg";